module.exports = __webpack_public_path__ + "static/media/copy-import-previous-goal.b99c1993.svg";